module.exports = __webpack_public_path__ + "img/LogoHorizontal_Dark.7c8942d8.png";